import {library} from '@fortawesome/fontawesome-svg-core';
import {faInfoCircle, faSpinner, faTimes} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

library.add(faInfoCircle, faSpinner, faTimes);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
